import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'border-border text-foreground',
        success: 'border-transparent bg-bright-moss-dark text-linen',
        info: 'border-transparent bg-atmosphere-dark text-linen',
        warning: 'border-transparent bg-fresh-salmon-dark text-linen',
        muted: 'border-transparent bg-muted text-muted-foreground',
        // Soft tints — light brand stop as the fill, dark stop as the
        // text. Lower-contrast siblings of the solid variants for chrome
        // (role chips, counts, metadata) where a solid pill would shout.
        'success-soft': 'border-bright-moss/60 bg-bright-moss/30 text-bright-moss-dark',
        'info-soft': 'border-info-soft/60 bg-info-soft/30 text-info',
        'warning-soft': 'border-fresh-salmon/60 bg-fresh-salmon/25 text-fresh-salmon-dark',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
